export const FILTERS_NAME_SET = 'SEARCHES/FILTERS/NAME/SET'
export const FORM_NAME_SET = 'SEARCHES/FORM/NAME/SET'
export const LAYOUT_TOGGLE = 'SEARCHES/LAYOUT/TOGGLE'
export const LIMIT_TOGGLE = 'SEARCHES/LIMIT/TOGGLE'
export const PAGE_SET = 'SEARCHES/PAGE/SET'

export const SEARCHES_GET = 'API|SEARCHES/GET'
export const SEARCHES_GET_FULFILLED = `FULFILLED_${SEARCHES_GET}`
export const SEARCHES_GET_PENDING = `PENDING_${SEARCHES_GET}`
export const SEARCHES_GET_REJECTED = `REJECTED_${SEARCHES_GET}`

export const SEARCH_DELETE = 'API|SEARCHES/DELETE'
export const SEARCH_DELETE_FULFILLED = `FULFILLED_${SEARCH_DELETE}`
export const SEARCH_DELETE_PENDING = `PENDING_${SEARCH_DELETE}`
export const SEARCH_DELETE_REJECTED = `REJECTED_${SEARCH_DELETE}`

export const SORT_BY_SET = 'SEARCHES/SORT_BY/SET'
export const SORT_ORDER_TOGGLE = 'SEARCHES/SORT_ORDER/TOGGLE'
